import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import GorgiasAppCredentialsStore from '../../../stores/credentials/gorgias-app-credentials-store';

interface IIntegrationProps {
    credentialsStore: GorgiasAppCredentialsStore,
    vGroup: IValidationGroup,
}

const GorgiasAppCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine 
                label='Subdomain'
                note='Enter your Gorgias subdomain. For example, if your Gorgias web address is https://returngo.gorgias.com, the subdomain would be "returngo".'
                required
                key='subdomain'
            >
                <Input
                    value={credentialsStore.subdomain}
                    placeholder=''
                    onChange={v => credentialsStore.subdomain = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default GorgiasAppCredentials;
